<div class="not-found">
  <h1>404</h1>
  <p>{{ 'app.errors.not_found' | translate }}</p>
</div>
